import DOMPurify from "dompurify";
import { useState } from "react";
import PopupSection from "../PopupSection";
const AIReadySection = ({ content }) => {
  const [popup, setPopup] = useState(false);
  return (
    <section className=" brr-none border-0 mb-0">
      <div className="container-custom sky-ps-bg-light-blue">
        <div className="row align-items-center flex-custom-col-reverse">
          <div className="col-md-12">
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(content?.heading || ""),
              }}
            />
            <div
              className="mb-4"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(content?.paragraph || ""),
              }}
            />

            <div className="button-group">
              <a className="white_btn" onClick={() => setPopup(true)}>
                Talk to Our Experts
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="19"
                    height="19"
                    rx="9.5"
                    stroke="black"
                  />
                  <path
                    d="M13.5211 12.7727L13.298 7.10815C13.2915 7.00261 13.2643 6.89775 13.2179 6.79958C13.129 6.60182 12.9682 6.44104 12.7705 6.35212C12.6723 6.30574 12.5675 6.27855 12.4619 6.27209L6.79738 6.04892C6.69175 6.04476 6.58797 6.06145 6.49198 6.09803C6.39598 6.1346 6.30964 6.19036 6.23789 6.26211C6.09299 6.40701 6.0163 6.60827 6.02471 6.8216C6.03311 7.03493 6.12592 7.24286 6.28271 7.39965C6.4395 7.55644 6.64743 7.64925 6.86076 7.65765L10.5935 7.79906L5.91933 12.4732C5.77502 12.6175 5.69864 12.8179 5.70701 13.0304C5.71539 13.2429 5.80781 13.4499 5.96396 13.6061C6.12012 13.7623 6.3272 13.8547 6.53966 13.863C6.75212 13.8714 6.95256 13.795 7.09687 13.6507L11.771 8.9766L11.9124 12.7093C11.9161 12.815 11.9408 12.9206 11.9849 13.02C12.029 13.1194 12.0918 13.2106 12.1695 13.2883C12.2472 13.366 12.3384 13.4287 12.4378 13.4729C12.5371 13.517 12.6427 13.5416 12.7485 13.5454C12.8542 13.55 12.9582 13.5336 13.0544 13.4972C13.1506 13.4607 13.2371 13.405 13.309 13.3332C13.3808 13.2613 13.4365 13.1748 13.4729 13.0786C13.5094 12.9824 13.5257 12.8785 13.5211 12.7727Z"
                    fill="black"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
      {popup && <PopupSection popup={(x) => setPopup(x)} />}
    </section>
  );
};

export default AIReadySection;
